import React from 'react';
import { CheckCircleIcon, AlertCircleIcon, XIcon } from 'lucide-react';
export const UploadResults = ({
  results,
  onClose
}) => {
  if (!results) return null;
  const {
    total,
    accepted,
    rejected,
    errors
  } = results;
  const successRate = Math.round(accepted / total * 100);
  return <div className="bg-white rounded-lg shadow overflow-hidden" data-id="element-664">
      <div className="p-6 flex justify-between items-start border-b" data-id="element-665">
        <div data-id="element-666">
          <h3 className="text-lg font-medium text-gray-900" data-id="element-667">
            Resultados de la Carga
          </h3>
          <p className="text-gray-500 mt-1" data-id="element-668">
            Se procesaron {total} registros en total
          </p>
        </div>
        <button onClick={onClose} className="text-gray-400 hover:text-gray-600" data-id="element-669">
          <XIcon className="h-5 w-5" data-id="element-670" />
        </button>
      </div>
      <div className="p-6" data-id="element-671">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6" data-id="element-672">
          <div className="bg-gray-50 p-4 rounded-lg" data-id="element-673">
            <p className="text-sm text-gray-500" data-id="element-674">Total Registros</p>
            <p className="text-2xl font-semibold" data-id="element-675">{total}</p>
          </div>
          <div className="bg-green-50 p-4 rounded-lg" data-id="element-676">
            <p className="text-sm text-green-600" data-id="element-677">Aceptados</p>
            <p className="text-2xl font-semibold text-green-700" data-id="element-678">{accepted}</p>
          </div>
          <div className="bg-red-50 p-4 rounded-lg" data-id="element-679">
            <p className="text-sm text-red-600" data-id="element-680">Rechazados</p>
            <p className="text-2xl font-semibold text-red-700" data-id="element-681">{rejected}</p>
          </div>
        </div>
        <div className="w-full bg-gray-200 rounded-full h-2.5 mb-6" data-id="element-682">
          <div className="bg-blue-600 h-2.5 rounded-full" style={{
          width: `${successRate}%`
        }} data-id="element-683"></div>
        </div>
        {errors.length > 0 && <div data-id="element-684">
            <h4 className="text-md font-medium text-gray-900 mb-4" data-id="element-685">
              Detalle de Errores
            </h4>
            <div className="overflow-x-auto" data-id="element-686">
              <table className="min-w-full divide-y divide-gray-200" data-id="element-687">
                <thead className="bg-gray-50" data-id="element-688">
                  <tr data-id="element-689">
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-690">
                      Línea
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-691">
                      Error
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-692">
                      Dato
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200" data-id="element-693">
                  {errors.map((error, index) => <tr key={index} data-id="element-694">
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900" data-id="element-695">
                        {error.line}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-red-600" data-id="element-696">
                        {error.reason}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-697">
                        {error.data}
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>
          </div>}
      </div>
      <div className="bg-gray-50 px-6 py-4 flex justify-end" data-id="element-698">
        <button onClick={onClose} className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700" data-id="element-699">
          Aceptar
        </button>
      </div>
    </div>;
};